import { Pipe, PipeTransform } from '@angular/core';
import { addDays } from 'date-fns';
import { DatePipe } from '@angular/common';
import { getDateInMerchantStore } from 'common-logic';

@Pipe({
  name: 'displayDateFormatter',
})
export class DisplayDateFormatterPipe extends DatePipe implements PipeTransform {
  override transform(value: any, args?: any): any {
    const date = new Date(value);
    const today = new Date().setHours(0, 0, 0, 0);
    const tomorrow = addDays(new Date(), 1).setHours(0, 0, 0, 0);
    const yesterday = addDays(new Date(), -1).setHours(0, 0, 0, 0);
    if (date.setHours(0, 0, 0, 0) == today) {
      return 'Today';
    } else if (date.setHours(0, 0, 0, 0) === tomorrow) {
      return 'Tomorrow';
    } else if (date.setHours(0, 0, 0, 0) === yesterday) {
      return 'Yesterday';
    } else {
      return super.transform(value, args);
    }
  }

  transformMerchantTime(value: any, args?: any) {
    const date = getDateInMerchantStore(value);
    const today = getDateInMerchantStore();
    const tomorrow = addDays(today, 1).setHours(0, 0, 0, 0);
    const yesterday = addDays(today, -1).setHours(0, 0, 0, 0);
    if (date.setHours(0, 0, 0, 0) == today.setHours(0, 0, 0, 0)) {
      return 'Today';
    } else if (date.setHours(0, 0, 0, 0) === tomorrow) {
      return 'Tomorrow';
    } else if (date.setHours(0, 0, 0, 0) === yesterday) {
      return 'Yesterday';
    } else {
      return super.transform(value, args);
    }
  }
}
